"use strict";

exports.__esModule = true;
exports.SortOption = exports.SortIcon = exports.FilterIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SortIcon = exports.SortIcon = function SortIcon(props) {
  var desc = props.desc,
    canSort = props.canSort;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  return desc !== undefined && canSort ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    size: 10,
    color: theme.color,
    style: {
      pointerEvents: "none",
      width: "10px",
      marginRight: "-6px",
      marginTop: "2px"
    },
    icon: desc ? _icons.IconNames.ARROW_DOWN : _icons.IconNames.ARROW_UP
  }) : null;
};
var FilterIcon = exports.FilterIcon = function FilterIcon(props) {
  var isFiltered = props.isFiltered,
    canFilter = props.canFilter,
    canSort = props.canSort;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  return canFilter || canSort ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    color: theme && theme.color ? theme.color : "defaultColor",
    style: {
      pointerEvents: "none",
      opacity: isFiltered ? "1" : "0.2"
    },
    icon: _icons.IconNames.FILTER
  }) : null;
};
var SortOption = exports.SortOption = function SortOption(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var accessor = props.accessor,
    setSorted = props.setSorted;
  var getUpdatedSorted = function getUpdatedSorted(isDescending) {
    return [{
      id: accessor,
      desc: isDescending
    }];
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    key: "asc",
    shouldDismissPopover: false,
    icon: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.SORT_ASC,
      style: {
        marginRight: "5px"
      },
      color: theme.color
    }),
    text: translate("DataTableFilter.sortAscending", "Sort Ascending"),
    onClick: function onClick() {
      setSorted(getUpdatedSorted(false));
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    key: "desc",
    icon: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.SORT_DESC,
      style: {
        marginRight: "5px"
      },
      color: theme.color
    }),
    shouldDismissPopover: false,
    text: translate("DataTableFilter.sortDescending", "Sort Descending"),
    onClick: function onClick() {
      setSorted(getUpdatedSorted(true));
    }
  }));
};